<div class="redirecting">
  <p>Redirecting to gamepass...</p>
</div>
